import { Component, ContentChild, Input, TemplateRef } from '@angular/core';
import { PayeeHeaderComponent } from '../../../shared/payee-header/payee-header.component';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-header-app',
  templateUrl: './header-app.component.html',
  styleUrls: ['./header-app.component.scss'],
  imports: [PayeeHeaderComponent, NgTemplateOutlet, RouterLink],
})
export class HeaderAppComponent {
  @Input() set xClicked(fn: () => void) {
    this.onXClicked = fn;
  }
  @Input({ required: true }) xLink!: string;
  @Input() payeeLink = 'https://payee.tech';

  @ContentChild('logoTemplate') logoTemplateRef?: TemplateRef<unknown>;

  onXClicked = () => {};
}
